import React from 'react';
import { connect } from 'react-redux';
import FlightsInfo from './FlightsInfo';
import { dateTolocale } from 'utils/converter';
import { DateTimeFormat } from 'custom/constants';
import http from 'utils/http';
import cookies from 'utils/cookies';
import moment from 'moment-timezone';

class FlightInfoContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showFlight: true,
      search: '',
      editField: false,
      ctype: props.ctype,
      buildUp: false,
      userContractTypes: [],
      flightData: null,
      contractTypesList: [],
      contractTypes: [],
      showNoOpPopup: false,
      noOpReason: '',
      noOpPendingChecked: false,
      noOpAnchor: null,
    };
    this.stn = cookies.get('station_code');
    this.noOpCheckboxRef = React.createRef();
  }

  componentDidMount() {
    this.updateNote();
    this.getConfig();
    if (this.props.printFunction) {
      this.props.printFunction(this.props.flight, 'flightInfo');
      this.setState({ flightData: this.props.flight }, () => {
        this.fetchUser();
        this.fetchContractTypes();
      });
    }
    if (this.props.showReportModal) {
      this.setState({ showFlight: true });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.flight !== this.props.flight) {
      this.setState({ flightData: this.props.flight }, () => {
        this.updateNote();
        this.getConfig();
        this.fetchUser();
        this.fetchContractTypes();
      });
    }
    if (prevProps.ctype !== this.props.ctype) {
      this.setState({ ctype: this.props.ctype });
    }
  }


  fetchUser = () => {
    console.log('Fetching user data...');
    http.get(`/user?id=${cookies.get('user')}`).then(({ data }) => {
      if (data && data.data && data.data.length > 0) {
        this.setState({ userContractTypes: data.data[0]?.contract_types || [] });
      }
    });
  };

  fetchContractTypes = () => {
    let from = moment(this.state.flightData?.flight_date).startOf('day').format('YYYY-MM-DD');
    let to = moment(this.state.flightData?.flight_date).endOf('day').format('YYYY-MM-DD');
    console.log('From:', from, 'To:', to);
    if (this.state.flightData) {
      http.get(`/check_contract?from=${from}&to=${to}`)
        .then(response => {
          const { data } = response;
          if (data.status === 'success') {
            this.setState({ contractTypesList: data.data }, () => this.filterContractTypes());
          }
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
    }
  };

  filterContractTypes = () => {
    console.log('Filtering contract types...');
    let contractTypesList = this.state.contractTypesList;
    let contractTypes = [];
    contractTypesList.map((contract) => {
      if (this.state.flightData?.airlineId === '') {
        contractTypes.push(contract.type);
      }
      if (this.state.flightData?.airline?.code === contract.airline.code) {
        contractTypes.push(contract.type);
      }
    });
    // remove records from contractTypes which are not present in userContractTypes
    contractTypes = contractTypes.filter((item) => this.state.userContractTypes.includes(item));
    contractTypes = [...new Set(contractTypes)];
    this.setState({ contractTypes: contractTypes }, () => console.log('Filtered contract types:', this.state.contractTypes));
  };

  getConfig = () => {
    http.get('/settings?key=buildup').then(({ data }) => {
      if (data.data) {
        let Buildup = data.data?.find((item) => item.key === 'buildup');
        if (Buildup) {
          if (Buildup?.value && Buildup.value?.data === 'true') {
            this.props.flight?.org == this.stn ? this.toggleBuildup(true) : this.toggleBuildup(false);
          }else
          {
            this.toggleBuildup(false);
          }
        }
      }
    });
    http.get('/settings?key=import').then(({ data }) => {
      if (data.data) {
        let Import = data.data?.find((item) => item.key === 'import');
        if (Import) {
          if (Import?.value && Import.value?.data === 'true') {
            this.props.flight?.dest == this.stn ? this.toggleImport(true) : this.toggleImport(false);
          }else
          {
            this.toggleImport(false);
          }
        }
      }
    });
  };

  toggleBuildup = (show) => {
    const buildupTabElement = document.getElementById('simple-tab-buildup');
    if (buildupTabElement) {
      if (show) {
        buildupTabElement.setAttribute('style', 'display: inline-flex');
      } else {
        buildupTabElement.setAttribute('style', 'display: none');
      }
    }
  };

  toggleImport = (show) => {
    console.log('Toggling import tab:', show);
    const importTabElement = document.getElementById('simple-tab-import_notification');
    if (importTabElement) {
      if (show) {
        importTabElement.setAttribute('style', 'display: inline-flex');
      } else {
        importTabElement.setAttribute('style', 'display: none');
      }
    }
  };

  updateNote = () => {
    const ffmNoteElement = document.getElementById('ffm-note');
    if (!ffmNoteElement) {
      console.error('Element with ID "ffm-note" not found.');
      return;
    }
    if (this.props.flight) {
      if (this.props.flight?.org == this.stn) {
        if (this.props.flight.out_ffm) {
          if (this.props.flight.out_ffm?.processing)
            ffmNoteElement.innerHTML = '<i>Processing ..</i>';
          else
            ffmNoteElement.innerHTML = `Uploaded on ${dateTolocale(this.props.flight.out_ffm.uploaded_date, DateTimeFormat)}`;
        } else {
          ffmNoteElement.innerHTML = '';
        }
      } else if (this.props.flight?.dest == this.stn) {
        if (this.props.flight.in_ffm) {
          if (this.props.flight.in_ffm?.processing)
            ffmNoteElement.innerHTML = '<i>Processing ..</i>';
          else
            ffmNoteElement.innerHTML = `Uploaded on ${dateTolocale(this.props.flight.in_ffm.uploaded_date, DateTimeFormat)}`;
        } else {
          ffmNoteElement.innerHTML = '';
        }
      } else {
        ffmNoteElement.innerHTML = '';
      }
    } else {
      ffmNoteElement.innerHTML = '';
    }
  };

  changeCheck = (e) => {
    this.setState({ showFlight: e.target.checked, });
  };

  onchangeSearch = (e) => {
    if (e.target.value.length == 3 && !isNaN(e.target.value) && this.state.search.length == 2) {
      e.target.value = e.target.value + '-';
    }

    this.setState({ search: e.target.value?.toUpperCase() });
  };

  handleSearch = () => {
    this.props.handleSearch(this.state.search);
  };

  onSelect = (e) => {
    this.props.handleCtype(e.target.value);
  };


  onEditField = (type) => {
    this.setState({ editField: type });
  };

  onChange = (field, pre_value, value) => {
    if (pre_value != value) {
      http.put(`flight_edit/${this.props.flight.id}`, { [field]: value }).then(() => {
        this.setState({ editField: false });
      });
    } else {
      this.setState({ editField: false });
    }
  };

  handleNoOpClick = (e) => {
    this.setState({
      showNoOpPopup: true,
      noOpPendingChecked: e.target.checked,
      noOpAnchor: this.noOpCheckboxRef.current,
    });
  };

  handleNoOpReasonChange = (e) => {
    this.setState({ noOpReason: e.target.value });
  };

  handleNoOpOk = () => {
    // Call the original handler with event and remarks
    if (typeof this.props.handleNoOpChange === 'function') {
      this.props.handleNoOpChange(
        { target: { checked: this.state.noOpPendingChecked } },
        this.state.noOpReason
      );
    }
    this.setState({
      showNoOpPopup: false,
      noOpReason: '',
      noOpPendingChecked: false,
    });
  };

  handleNoOpCancel = () => {
    this.setState({
      showNoOpPopup: false,
      noOpReason: '',
      noOpPendingChecked: false,
    });
  };

  render() {
    return (
      <>
        <FlightsInfo
          ctype={this.state.ctype}
          onSelect={this.onSelect}
          editField={this.state.editField}
          onEditField={this.onEditField}
          onChange={this.onChange}
          flightData={this.props.flight}
          showFlight={this.state.showFlight}
          search={this.state.search}
          handleSearch={this.handleSearch}
          onchangeSearch={this.onchangeSearch}
          changeCheck={this.changeCheck}
          contractTypesList={this.state.contractTypesList}
          contractTypes={this.state.contractTypes}
          showReportModal={this.props.showReportModal}
          printFunction={this.props.printFunction}
          disableNoOp={this.props.disableNoOp}
          isNoOp={this.props.isNoOp}
          handleNoOpChange={this.props.handleNoOpChange}

          handleNoOpClick={this.handleNoOpClick}
          noOpCheckboxRef={this.noOpCheckboxRef}
          showNoOpPopup={this.state.showNoOpPopup}
          noOpReason={this.state.noOpReason}
          handleNoOpReasonChange={this.handleNoOpReasonChange}
          handleNoOpOk={this.handleNoOpOk}
          handleNoOpCancel={this.handleNoOpCancel}
        />
        
      </>
    );
  }
}


const mapStateToProps = (state) => {
  return { flight: state.flightInfo };
};

export default connect(mapStateToProps)(FlightInfoContainer);